if (!customElements.get('sumitomo-product-tabs')) {
  customElements.define(
    'sumitomo-product-tabs',
    class SumitomoProductTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-tab-button]')];
        this.panels = [...this.querySelectorAll('[data-tab-panel]')];
        this.buttons.forEach((btn, i) => btn.addEventListener('click', () => this.select(i)));

        // Theme editor: reveal the tab whose block is selected.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.buttons.indexOf(e.target);
          if (i >= 0) this.select(i);
        });
      }

      select(index) {
        this.buttons.forEach((btn, i) => {
          btn.classList.toggle('active', i === index);
          btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
      }
    }
  );
}
